/* Homepage catalogue scrolling only. Category tabs remain owned by ziqing.js. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-zhc-root]').forEach((root) => {
      if (root.dataset.zhcReady === 'true') return;
      root.dataset.zhcReady = 'true';
      const panels = [...root.querySelectorAll('.zhc-panel')];
      const states = panels.map((panel) => {
        const track = panel.querySelector('[data-zhc-track]');
        const arrows = panel.querySelector('[data-zhc-arrows]');
        const previous = panel.querySelector('[data-zhc-prev]');
        const next = panel.querySelector('[data-zhc-next]');
        if (!track) return null;
        let frame = 0;
        const update = () => {
          frame = 0;
          if (panel.hidden || !track.clientWidth) return;
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          if (arrows) arrows.hidden = maximum <= 2;
          if (previous) previous.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= maximum - 2;
        };
        const schedule = () => {
          if (!frame) frame = window.requestAnimationFrame(update);
        };
        const scrollTo = (left) => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: Math.max(0, Math.min(maximum, left)), behavior: reducedMotion ? 'instant' : 'smooth' });
          schedule();
        };
        const move = (direction) => {
          const first = track.firstElementChild;
          const second = first?.nextElementSibling;
          const step = second ? second.offsetLeft - first.offsetLeft : first?.getBoundingClientRect().width || track.clientWidth;
          scrollTo(track.scrollLeft + direction * Math.max(1, step));
        };
        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', schedule, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.ctrlKey || event.metaKey || event.altKey) return;
          if (event.target !== track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') scrollTo(0);
          else if (event.key === 'End') scrollTo(track.scrollWidth);
          else move(event.key === 'ArrowRight' ? 1 : -1);
        });
        if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
        else window.addEventListener('resize', schedule, { passive: true });
        schedule();
        return { panel, track, schedule };
      }).filter(Boolean);
      // Existing tab code changes hidden; reset newly selected categories to their first model.
      const observer = new MutationObserver((changes) => {
        changes.forEach((change) => {
          const state = states.find((entry) => entry.panel === change.target);
          if (state && !state.panel.hidden) {
            state.track.scrollTo({ left: 0, behavior: 'instant' });
            state.schedule();
          }
        });
      });
      states.forEach(({ panel }) => observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
